import { render, staticRenderFns } from "./TouTiao.vue?vue&type=template&id=94023d7c&scoped=true"
import script from "./TouTiao.vue?vue&type=script&lang=js"
export * from "./TouTiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94023d7c",
  null
  
)

export default component.exports